import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  UpdateButton,
} from "../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAlldepartments,
  getallPermissions,
  getAllUimodules,
  updatePermission,
} from "../../redux/features/permissionSlice";

const UpdatePermission = ({ rowData, dispatchparams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, uimodules, departments } = useSelector(
    (state) => state.permission
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: rowData.description,
      path: rowData.path,
      title: rowData.title,
      module: rowData.module_id,
      menuItem: rowData.menuItem,
      department_id: rowData.dept_id,
      permissionID: rowData.permissionID,
      module_name: rowData.module,
    },
    onSubmit: (values) => {
      dispatch(updatePermission({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getallPermissions(dispatchparams));
          formik.resetForm();
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  const menuitems = [
    { id: 0, name: "Sidebar" },
    { id: -1, name: "Other" },
  ];

  useEffect(() => {
    if (open) {
      dispatch(getAlldepartments());
      dispatch(getAllUimodules());
    }
  }, [open]);

  const handledepartment = (e, option) => {
    formik.setFieldValue("department_id", option?.dept_id);
  };
  const handlemodules = (e, option) => {
    formik.setFieldValue("module", option?.module_id);
  };

  return (
    <GlobalDialog
      title={"Update Permission"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Title"
                  />
                  <TextField
                    name="path"
                    value={formik.values.path}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Path"
                  />
                  <TextField
                    name="description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Description"
                  />
                  <Autocomplete
                    fullWidth
                    name="module"
                    options={uimodules}
                    getOptionLabel={(option) => option.module_name || ""}
                    value={
                      uimodules?.find(
                        (d) => d?.module_id == formik.values.module
                      ) || null
                    }
                    onChange={handlemodules}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Module"
                        error={
                          formik.touched.module && Boolean(formik.errors.module)
                        }
                        helperText={
                          formik.touched.module && formik.errors.module
                        }
                      />
                    )}
                  />
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "menuItem",
                      label: "Menu item",
                      data: menuitems,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  />
                  <Autocomplete
                    fullWidth
                    name="department_id"
                    options={departments}
                    getOptionLabel={(option) => option.dept_name || ""}
                    value={
                      departments?.find(
                        (d) => d?.dept_id == formik.values.department_id
                      ) || null
                    }
                    onChange={handledepartment}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="Department"
                        error={
                          formik.touched.department_id &&
                          Boolean(formik.errors.department_id)
                        }
                        helperText={
                          formik.touched.department_id &&
                          formik.errors.department_id
                        }
                      />
                    )}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default UpdatePermission;
